import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-search-icon",
  "use": "svg-search-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-search-icon\"><path d=\"M731.733333 675.584a28.885333 28.885333 0 0 1 11.093334 6.954667l164.010666 163.968a29.013333 29.013333 0 0 1-40.96 41.002666l-164.010666-163.968a28.928 28.928 0 0 1-6.144-9.045333 338.176 338.176 0 1 1 35.968-38.912z m-265.557333 70.826667a280.192 280.192 0 1 0 0-560.426667 280.192 280.192 0 0 0 0 560.384z\" fill=\"currentColor\" p-id=\"2927\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol